import { getPalette } from 'owa-theme';
import { createTheme, Theme } from '@fluentui/react';
import { computed } from 'mobx';

const createCurrentRibbonTheme = computed(
    (): Theme => {
        // Both OWA and WAC color themes are built around fluent's Theme interface,
        // however, there are some slight semantic differences in usage. This mapping, when
        // applied to only the ribbon region, resolves the problematic differences.

        // OWA's Toolbar uses neutralLight for background and neutralLight for pressed button background
        // Ribbon's background uses neutralLighterAlt and neutralLighter for button hover background
        // In short: These two values can be swapped
        // For reference: WAC semantic definition can be found in actionControlSemanticColorsWithTheme
        // within acui-common/src/styling/actionControlSematicColors.ts.
        const owaPalette = getPalette();
        const wacSemanticPalette = {
            ...owaPalette,
            neutralLighter: owaPalette.neutralLight, // hoverBackgroundColor
            neutralLighterAlt: owaPalette.neutralLighter, // defaultBackgroundColor
        };
        return createTheme({ palette: wacSemanticPalette });
    }
);

export const getCurrentRibbonTheme = () => createCurrentRibbonTheme.get();
